module.exports = __webpack_public_path__ + "static/media/araciste-logo.e48e312a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/araciste-logo.png
// module id = 599
// module chunks = 0